@use "../../sass/variables/colors";

:host {
  display: inline-block;
  min-height: 44px;
  min-width: 44px;

  ux-icon {
    font-size: 18px;
  }

  ux-button:hover {
    ux-icon {
      fill: colors.$color-white;
    }
  }
}
